import * as React from "react";
import { CommentsCompareSelectDialog, CompareItems } from "./CommentsCompareSelectDialog";
import { TestFixedCommentsState, ToggleAlertFixedCommentCheckedAction, ToggleAlertFixedCommentsVisibilityAction, ToggleTestFixedCommentCheckedAction, ToggleTestFixedCommentsVisibilityAction } from "./UseFixedComments";

export interface EcgCommentModalsProps {
    editable: boolean;
    testFixedComments: TestFixedCommentsState[];
    alertFixedComments: TestFixedCommentsState[];
    testComparisonFixedComments?: CompareItems[];
    alertComparisonFixedComments?: CompareItems[];
    dispatch: React.Dispatch<any>;
}

export const EcgCommentModals = ({ editable, testFixedComments, alertFixedComments, testComparisonFixedComments = [], alertComparisonFixedComments = [], dispatch }: EcgCommentModalsProps) => {
    const renderInterpretationModals = () => {
        return (
            testFixedComments.map((tfc) => {
                return (
                    <CommentsCompareSelectDialog
                        key={`CommentsDialog${tfc.id}`}
                        editable={editable}
                        show={tfc.isVisible}
                        header={`Interpretations - Recording ${tfc.testNumber}`}
                        items={tfc.comments}
                        compareItems={testComparisonFixedComments}
                        showFilter={true}
                        onChange={(id, checked) => dispatch(ToggleTestFixedCommentCheckedAction.create(tfc.id, id, checked))}
                        onClose={() => dispatch(ToggleTestFixedCommentsVisibilityAction.create(tfc.id))}
                    />
                );
            })
        );
    }

    const renderAlertModals = () => {
        return (
            alertFixedComments.map((tfc) => {
                return (
                    <CommentsCompareSelectDialog
                        key={`CommentsDialog${tfc.id}`}
                        editable={editable}
                        show={tfc.isVisible}
                        header={`Alerts - Recording ${tfc.testNumber}`}
                        items={tfc.comments}
                        compareItems={alertComparisonFixedComments}
                        showFilter={true}
                        onChange={(id, checked) => dispatch(ToggleAlertFixedCommentCheckedAction.create(tfc.id, id, checked))}
                        onClose={() => dispatch(ToggleAlertFixedCommentsVisibilityAction.create(tfc.id))}
                    />
                );
            })
        );
    }

    return (
        <>
            {renderInterpretationModals()}
            {renderAlertModals()}
        </>
    );
}
